export interface IPassportReminderData {
  employeeId: number;
  expirationDate: string;
  daysRemaining: number;
}

export function isPassportReminderData(data: unknown): data is IPassportReminderData {
  if (data == null || typeof data !== 'object') {
    return false;
  }

  const candidate = data as Partial<IPassportReminderData>;
  return (
    typeof candidate.employeeId === 'number' && typeof candidate.expirationDate === 'string' && typeof candidate.daysRemaining === 'number'
  );
}
